import { compactSpaces } from '../../../../utils/helpers/string.helper';
import { Client } from '../../../client-data/client.model';

export const clientTmpl = (liDom: any, client: Client) => {
  let clientNameHtml = `
      <strong class="client-billing-name">
        ${client.billingName}
      </strong>
      `,
    clientEmailHtml;

  if (client.email) {
    clientEmailHtml = `
      <span class="client-email">
        ${client.email}
      </span>`;
  }

  let contents = `
    <div class="client-contents">
      ${clientNameHtml}  
      
      ${clientEmailHtml || ''}
    </div>
  `;

  liDom.innerHTML = compactSpaces(contents);
};

export const categoryTmpl = (
  label: string,
  categoryDom: any,
  query: string
) => {
  const contents = query
    ? ''
    : `
      <div class="category-header">
        <span class="category-label">
          ${label}
        </span>
      
        <hr class="category-divider" />
      </div>  
    `;

  categoryDom.innerHTML = compactSpaces(contents);
};
